import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {Component} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvService} from '../../services/env.service';
import {AlertService} from '../../services/alert.service';

@Component({
  selector: 'micro-event-dialog',
  templateUrl: './event-dialog.component.html'
})
export class MicroEventDialogComponent {

  public title:string = 'Pick an event';
  public event:any;
  public confirmText:string = 'Pick';
  public eventType:string;
  public eventSource:string;
  public selectedReactorLog:any;

  constructor(public dialogRef: MatDialogRef<MicroEventDialogComponent>,
              private http:HttpClient,
              private env:EnvService,
              private alertService:AlertService) {
  }

  onEventTypeChange():void {
    this.event = null;
    this.selectedReactorLog = null;
  }

  onReactorLogSelected(selectedLog:any):void {
    this.event = null;
    this.selectedReactorLog = selectedLog;
    if (!selectedLog) {
      return;
    }

    this.http.get(`${this.env.e.url}/reactor/logs/${selectedLog.id}`).subscribe(data => {
      if (this.eventType !== 'reactor_webhook' || this.selectedReactorLog !== selectedLog) {
        return;
      }

      try {
        const input = JSON.parse((data as any).input);
        if (input?.type !== 'reactor_webhook' || !input.value ||
            typeof input.value !== 'object' || Array.isArray(input.value)) {
          this.alertService.warn('The selected reactor log does not contain a webhook event.');
          return;
        }
        this.event = input.value;
      } catch (error) {
        this.alertService.warn('The selected reactor log does not contain valid JSON input.');
      }
    });
  }

  confirm():void {
    this.close(true);
  }

  cancel():void {
    this.close(false);
  }

  close(confirmed:boolean):void {
    this.dialogRef.close({confirmed:confirmed, event:this.event, eventType:this.eventType});
  }
}
